module.exports = __webpack_public_path__ + "media/images/common/about/icon_travel-2ac523fc3ccf431bdf6224bb06d95e22.svg";